import { z } from "zod";

export const environments = ["development", "staging", "production"] as const;
export const environmentSchema = z.enum(environments);
export type Environment = z.infer<typeof environmentSchema>;

export const healthSchema = z.object({ status: z.literal("ok") });
export type Health = z.infer<typeof healthSchema>;

/** Identifies the running build. Never carries secrets or configuration values. */
export const metaSchema = z.object({
  service: z.string().min(1),
  version: z.string().min(1),
  commit: z.string().min(1),
  environment: environmentSchema,
});
export type Meta = z.infer<typeof metaSchema>;
